import React from 'react';
import { LayersIcon, ZapIcon, SmartphoneIcon, TargetIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1024;
const HERO_IMG_HEIGHT = 1024;
const badges = [{
  icon: LayersIcon,
  label: 'Estrategias paso a paso'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: TargetIcon,
  label: 'Enfocado en conseguir clientes'
}, {
  icon: SmartphoneIcon,
  label: '100% digital'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-sand" data-id="element-150" data-mp="nczrv382dxu1">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-sage-soft blur-3xl" aria-hidden data-id="element-151" data-mp="nekkuoeqd8ps" />
      <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-gold-soft/70 blur-3xl" aria-hidden data-id="element-152" data-mp="382ffxqfwf8fz" />

      <div className="relative mx-auto max-w-3xl px-5 py-6 text-center sm:py-12" data-id="element-153" data-mp="3j7zgfm2d3yi9">
        <div className="animate-hero-copy" data-id="element-154" data-mp="3o7lprkf2kuls">
          <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.66rem]" data-id="element-155" data-mp="3o6aq9wsnq90h">
            Para coaches que quieren crecer
          </p>
          <h1 className="mx-auto mt-2.5 max-w-[18ch] font-display text-[1.75rem] font-bold uppercase leading-[1.08] text-charcoal sm:max-w-[24ch] sm:text-[2.7rem]" data-id="element-156" data-mp="3e8msexzr8le3">
            Convertí tu conocimiento
            <span className="mt-1 block text-gold-deep" data-id="element-157" data-mp="358zu4l2bnvp9">en clientes</span>
          </h1>
          <p className="mx-auto mt-3 max-w-[34ch] font-sans text-[0.88rem] leading-relaxed text-charcoal/75 sm:max-w-xl sm:text-[0.95rem]" data-id="element-158" data-mp="2qkd9q4xu8dr6">
            El Mega Pack <strong className="font-semibold text-charcoal" data-id="element-159" data-mp="2vgu0l6wf967y">6 en 1</strong> para que tu
            experiencia se vea, se entienda y se convierta en consultas. Sin volverte experto en
            marketing.
          </p>
        </div>

        <img src={HERO_IMG} alt="Mega Pack Coach Digital PRO: los seis tomos del sistema junto a una tablet y un celular" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 60vw, 380px" style={{
        aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
      }} className="animate-hero-media mx-auto mt-3 block h-auto w-[58%] max-w-[230px] rounded-xl object-contain sm:mt-5 sm:w-[70%] sm:max-w-[380px]" data-id="element-160" data-mp="s1rt2qgj2avc" />

        <p className="mt-3 font-sans text-[0.92rem] font-semibold text-charcoal sm:text-lg" data-id="element-161" data-mp="162lzj3k0m1rd">
          6 tomos + 5 bonos de regalo
        </p>

        <PriceBlock className="mt-1.5" data-id="element-162" data-mp="x1ec5gj1elc2" />

        <div className="mt-3.5 flex justify-center" data-id="element-163" data-mp="x0l48c8cdpsc">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-164" data-mp="3lsp49g06snfh" />
        </div>

        <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-165" data-mp="3lqm2jypo95ux">
          Acceso inmediato · 100% digital · Aplicalo a tu propio negocio
        </p>
        <p className="mt-1 font-sans text-[0.7rem] text-charcoal/50" data-id="element-166" data-mp="1xam6asypfuzz">
          🔒 Pago seguro · Mercado Pago · Tarjetas de crédito
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-1.5" data-id="element-167" data-mp="218jzs7zid396">
          {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-2.5 py-1.5 font-sans text-[0.66rem] font-medium text-charcoal/80" data-id="element-168" data-mp="2b0fxhhxomrcv">
              <b.icon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-169" data-mp="2kxuebinipi5p" />
              {b.label}
            </span>)}
        </div>
      </div>

      <div className="relative border-t border-stone bg-ivory/70" data-id="element-170" data-mp="2tzlg4cext4ua">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-5 gap-y-1.5 px-5 py-3 text-center font-sans text-[0.74rem] text-charcoal/70" data-id="element-171" data-mp="2tysic0xyhpoa">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-172" data-mp="znn8gewa0h0i" data-mpi={i}>
              {i > 0 && <span className="hidden h-3.5 w-px bg-stone-deep sm:block" aria-hidden data-id="element-173" data-mp="4akx2ytnmkfz" />}
              <span data-id="element-174" data-mp="3vi70qrgdimwu">{fact}</span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}